module.exports = __webpack_public_path__ + "img/744.00bc79df.jpg";